import { render, staticRenderFns } from "./BotaoOperacoes.vue?vue&type=template&id=fd4e4098&lang=pug"
import script from "./BotaoOperacoes.vue?vue&type=script&lang=js"
export * from "./BotaoOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports